// @flow
/* eslint-disable no-shadow */
import React from 'react'
import Modal from 'react-modal'
import { connect } from 'react-redux'
import { updateClient, cancelClientUpdate } from '../../actions/forms'
import UpdateClientForm from '../UpdateClientForm'
import Button from '../Button'

type Props = {
  client: Object,
  isOpen: boolean,
  updateClient: Function,
  cancelClientUpdate: Function
}

const ConsultationModal = ({
  client,
  isOpen,
  updateClient,
  cancelClientUpdate
}: Props) => {
  if (!isOpen) return null

  return (
    <Modal
      isOpen={isOpen}
      className="modal"
      contentLabel="Home Value Consultation"
      overlayClassName="modal-overlay"
      onRequestClose={cancelClientUpdate}
    >
      <div className="modal-header">
        <h5 style={{ marginBottom: 0 }}>Thank You</h5>
        <button
          type="button"
          className="modal-close"
          onClick={cancelClientUpdate}
        >
          &times;
        </button>
      </div>
      <div className="modal-content">
        <p>
          Your request has been received. To help us better serve you, could you
          please provide some additional details about your home?
        </p>
        <UpdateClientForm
          enableReinitialize
          clientId={client.id}
          initialValues={{
            ...client,
            basement_type: 'None',
            state: client.state ? client.state : 'IL'
          }}
          onSubmit={updateClient}
        />
      </div>
      <div className="modal-footer" style={{ textAlign: 'center' }}>
        <Button type="button" onClick={cancelClientUpdate}>
          Return to Website
        </Button>
      </div>
    </Modal>
  )
}

export default connect(
  (state) => ({
    client: state.session.currentClient,
    isOpen: state.modals.consultationModalOpen
  }),
  {
    updateClient,
    cancelClientUpdate
  }
)(ConsultationModal)



// WEBPACK FOOTER //
// ./src/components/ConsultationModal/index.js